import styled from 'styled-components';

const QModalBody = styled.div`
  width: 100%;
  padding: 0 5em;
`;

export default QModalBody;
